import { takeEvery } from 'redux-saga/effects'
import { gCall } from './utils'
import * as action from '../actions'
import api from '../middleware/api'

function* watchForLoginSucceeded() {
  yield takeEvery(action.PEOPLE_LOG_FETCH,
    gCall(api.fetchPeopleLog, action.peopleLogFetchSucceeded, action.peopleLogFetchFailed),
  )
}

export default [watchForLoginSucceeded]



// WEBPACK FOOTER //
// ./src/sagas/people_log.jsx